import { AppointmentActionErrors } from '@appointments/store/enums/appointment-action-errors';

export const APPOINTMENT_ERRORS_MAP = new Map<string, AppointmentActionErrors>([
    ['Create_Appointment_Failed', AppointmentActionErrors.AppointmentCreation],
    ['Update_Appointment_Failed', AppointmentActionErrors.AppointmentUpdate],
    ['Delete_Appointment_Failed', AppointmentActionErrors.AppointmentDeletion],
    ['Change_Appointment_Status_Failed', AppointmentActionErrors.AppointmentStatusUpdate],
    ['Listing_Removed_Error', AppointmentActionErrors.ListingRemovedError]
]);